export enum InputState {
  None = 0,
  Pristine = 1 << 0,
  Untouched = 1 << 1,
  Invalid = 1 << 2,
  Empty = 1 << 3,
  Blurred = 1 << 4,
}
